import {
  REMEMBER_ME,
  FORGET_ME,
  LOGIN_SUCCESS,
  LOGOUT,
} from "../../constants/Constants";

const initialState = {
  token: null,
  isAuthenticated: false,
  rememberedUsername: "",
  rememberedPassword: "",
};

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        token: action.payload,
        isAuthenticated: true,
      };

    case LOGOUT:
      return {
        ...state,
        token: null,
        isAuthenticated: false,
      };

    case FORGET_ME:
      return {
        ...state,
        rememberedUsername: "",
        rememberedPassword: "",
      };

    case REMEMBER_ME:
      return {
        ...state,
        rememberedUsername: action.payload.username,
        rememberedPassword: action.payload.password,
      };

    default:
      return state;
  }
};
